export default __webpack_public_path__ + "static/media/clipboard-illustration.42a2c5d1.svg";